// src/App.tsx
import React from 'react';
import './App.css';
import TermsOfService from './components/TermsOfService';

const App: React.FC = () => {
  return (
    <div className="App">
      <TermsOfService />
    </div>
  );
}

export default App;
